export enum TipoFiltroActServicioCliente {
  IDENTIFICACION = 'IDENTIFICACIÓN',
  RAZON_SOCIAL = 'RAZÓN SOCIAL',
  PPPOE = 'PPPOE',
}

export const CHOICES_TIPOFILTROACTSERVICIOCLIENTE = [
    TipoFiltroActServicioCliente.IDENTIFICACION,
    TipoFiltroActServicioCliente.RAZON_SOCIAL,
    TipoFiltroActServicioCliente.PPPOE,
]